import makeTable from "./makeTable";

const vehicleType = makeTable({
	allIds: ["checkbox", "active", "name", "bodyType", "company", "branch"],
	i18tPath: (id) => `tableColumns.vehicleTypes.${id}`,
});

export default vehicleType;
